/** 按彩种 id 返回专用投注页路径（其余走通用 /bet） */
export function getBetPath (gameId) {
  const id = Number(gameId)
  if (id === 14) return '/bet/fc3d'
  if (id === 15) return '/bet' // 体彩P3P5 走通用盘
  if (id === 16) return '/bet/dlt'
  if (id === 17) return '/bet/ssq'
  if (id === 1103) return '/bet/tc-lhc'
  if (id === 1909) return '/bet/tc-k3'
  if (id === 21503) return '/bet/tc-keno8'
  if (id === 19503) return '/bet' // 澳门飞艇
  return '/bet'
}

export function getTrendPath (gameId) {
  const id = Number(gameId)
  if (id === 1103) return '/trend/tc-lhc'
  if (id === 21503) return '/trend/tc-keno8'
  return '/trend'
}

/** 统一跳转投注页，避免双色球/大乐透停在通用 /bet */
export function navigateToBet (router, gameId, { replace = false } = {}) {
  const id = Number(gameId)
  if (!(id > 0) || !router) return
  const path = getBetPath(id)
  const loc = { path, query: { id } }
  if (replace) router.replace(loc)
  else router.push(loc)
}
